"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../controllers/BaseController");
var DlgUploadProgressCtl = /** @class */ (function (_super) {
    __extends(DlgUploadProgressCtl, _super);
    function DlgUploadProgressCtl() {
        return _super.call(this, true) || this;
    }
    DlgUploadProgressCtl.prototype.ResetData = function () {
        this.DATA = {
            visible: false,
            progressTitle: "",
            progressText: "",
            progressPercent: 0,
            displayMode: "progress",
            errorTitle: "",
            errorText: "",
            isCanClose: false,
            onClose: null
        };
    };
    DlgUploadProgressCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgUploadProgressCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgUploadProgressCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    DlgUploadProgressCtl.prototype.SetAllParams = function (val) {
        this.DATA = val;
        this.Update();
        return this;
    };
    DlgUploadProgressCtl.prototype.SetDisplayMode = function (val) {
        this.DATA.displayMode = val;
        this.Update();
        return this;
    };
    DlgUploadProgressCtl.prototype.SetCanClose = function (val) {
        this.DATA.isCanClose = val;
        this.Update();
        return this;
    };
    DlgUploadProgressCtl.prototype.SetProgressPercent = function (val) {
        this.DATA.progressPercent = val;
        this.Update();
        return this;
    };
    DlgUploadProgressCtl.prototype.SetProgressText = function (val) {
        this.DATA.progressText = val;
        this.Update();
        return this;
    };
    DlgUploadProgressCtl.prototype.SetErrorText = function (val) {
        this.DATA.errorText = val;
        this.Update();
        return this;
    };
    DlgUploadProgressCtl.prototype.SetProgressTitle = function (val) {
        this.DATA.progressTitle = val;
        this.Update();
        return this;
    };
    DlgUploadProgressCtl.prototype.SetErrorTitle = function (val) {
        this.DATA.errorTitle = val;
        this.Update();
        return this;
    };
    DlgUploadProgressCtl.prototype.SetOnCloseClick = function (callback) {
        this.DATA.onClose = callback;
        this.Update();
        return this;
    };
    return DlgUploadProgressCtl;
}(BaseController_1.BaseController));
exports.DlgUploadProgressCtl = DlgUploadProgressCtl;



//////////////////
// WEBPACK FOOTER
// ./src/shared/dialogs/ctl/DlgUploadProgessCtl.ts
// module id = 901
// module chunks = 0